import { mergeObjectTypes } from '../cacheHelpers';

const ConsolidatedShipment = {
  merge: mergeObjectTypes
};

export default ConsolidatedShipment;
